import type { ReactNode } from 'react';
import { cx } from './cx';

/** Label + control + optional help text. Give the control `className="input"` and the matching `id`. */
export function Field({ label, htmlFor, help, children, className }: { label: ReactNode; htmlFor: string; help?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <div className={cx('field', className)}>
      <label htmlFor={htmlFor} className="field__label">
        {label}
      </label>
      {children}
      {help && <p className="field__help">{help}</p>}
    </div>
  );
}
